import { SortOptions } from './CommonSortOptions';
import { CrassSortOptions } from './CrassSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';


export const databaseSortOptionsCrass: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'workbooks': CrassSortOptions.downstreamWorkbookCount,
  'datasources': CrassSortOptions.downstreamDataSourceCount,
  'connectionType': CrassSortOptions.connectionType,
  'isCertified': CrassSortOptions.isCertified,
};
